import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=bf03fdd8&scoped=true&"
import script from "./InfoRow.vue?vue&type=script&lang=js&"
export * from "./InfoRow.vue?vue&type=script&lang=js&"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=bf03fdd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf03fdd8",
  null
  
)

export default component.exports